import { render, staticRenderFns } from "./TourEdit.vue?vue&type=template&id=89a164bc"
import script from "./TourEdit.vue?vue&type=script&lang=js"
export * from "./TourEdit.vue?vue&type=script&lang=js"
import style0 from "./TourEdit.vue?vue&type=style&index=0&id=89a164bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports